const border = {
    small: {
        radius: '10px',
        width: '1px',
        style: 'solid',
    },
    medium: {
        radius: '20px',
        width: '0px',
        style: 'solid',
    },
    large: {
        radius: '30px',
        width: '5px',
        style: 'solid',
    },
};

export default border;
